<template>
  <v-menu
    dense
    :offset-x='offsetX'
    :offset-y='offsetY'
    :top='top'
    :bottom='bottom'
    :nudge-left="left?'4':'0'"
    :nudge-right="right?'4':'0'"
    :left='left'
    :right='right'
    :close-on-content-click='false'
    :value='showSearch'
  >
    <template v-slot:activator='{ on }'>
      <v-btn v-on='on' small icon @click='openSearch'>
        <v-icon :color="value ? 'red' : 'grey lighten-1'">mdi-magnify</v-icon>
      </v-btn>
    </template>
    <span>
      <wc-data-box hideToolbar>
        <v-text-field
          class='mx-3'
          ref='toolbarSearch'
          placeholder='Search'
          prepend-inner-icon='mdi-magnify'
          @input="$emit('input', arguments[0])"
          clearable
          @click:clear='showSearch = false'
        >
        </v-text-field>
      </wc-data-box>
    </span>
  </v-menu>
</template>

<script>
export default {
  name: 'wc-toolbar-search',
  // props: ['value'],
  props: {
    value: {
      required: true
    },
    left : {
      required: false,
      type: Boolean,
      default: true
    },
    right: {
      required: false,
      type: Boolean,
      default: false
    },
    top : {
      required: false,
      type: Boolean,
      default: true
    },
    bottom : {
      required: false,
      type: Boolean,
      default: false
    },
    offsetX : {
      required: false,
      type: Boolean,
      default: true
    },
    offsetY : {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showSearch: false
  }),
  methods: {
    openSearch () {
      this.showSearch = true
      setTimeout(() => {
        this.$refs.toolbarSearch.focus()
      }, 100)
    }
  }
}
</script>
